import { MonthlyOffers } from "../home/monthlyOffers";

export function OtherOffers() {
  return <MonthlyOffers id="4ljacktE3qwRMd0vqpfx3W" size={3} />;
}
